import React from 'react';

const entryUrl = (entry) => {
  //strip cms:// from entry.img
  if (!entry?.img) return '';
  return `/preview/asset/${entry.img.replace('cms://', '')}?instanceName=live&reload=${Date.now()}`;
};

const Section1 = ({ entry }) => (
  <div className="col-xs-3">
    {entry?.img ? (
      <span>
        <img className="max-height-100-img" src={entryUrl(entry)} />
      </span>
    ) : null}
  </div>
);

export default Section1;
